import {Component, Input} from '@angular/core';
import {CardInfoContatoComponent} from '../card-info-contato/card-info-contato.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-metricas',
  standalone: true,
  imports: [
    CardInfoContatoComponent,
    NgClass
  ],
  templateUrl: './metricas.component.html',
  styleUrl: './metricas.component.css'
})
export class MetricasComponent{
  @Input() quantidadeEnviados?: number;
  @Input() quantidadeRecebidos?: number;
  @Input() quantidadeLidos?: number;
  @Input() quantidadePorcentagemConversao?: number;
  @Input() quantidadePesquisasRespondidas?: number;
  @Input() quantidadePorcentagemPesquisasRespondidas?: number;
  @Input() quantidadeErros?: number;
  @Input() quantidadeBlacklist?: number;
  @Input() quantidadeInvalidos?: number;
  @Input() quantidadeEmProcessamento?: number;
  @Input() interacao?: number;
  @Input() possuemSessao?: number;
  @Input() isFluxoPesquisa = false;
  @Input() ehMobile?: boolean;
  @Input() custoDisparo?: number;
  @Input() moedaCusto: 'BRL' | 'USD' | 'EUR' = 'USD';
  @Input() tipoDisparo?: string;

  get ehEmailOuSms(): boolean {
    const tipo = this.tipoDisparo?.toLowerCase();
    return tipo === 'email' || tipo === 'sms';
  }

  get ehEmail(): boolean {
    return this.tipoDisparo?.toLowerCase() === 'email';
  }
}
